/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Preview/view.blocks to change it.
import * as fromData from 'Simple/Data'
import PreviewResource from 'DesignSystem/PreviewResource/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Preview({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/ViewTraces/Content/Preview"
  
}) {
let selectedValueData = fromData.useDataValue({ viewPath,
context: 'selected',
})
  return (<React.Fragment
>
<PreviewResource
  viewPath={`${viewPath}/PreviewResource`}
 data="selected"
 resource={selectedValueData}
/>
{children}
</React.Fragment>)
}